export default __webpack_public_path__ + "static/media/arado.dd8b2f4f.png";